import { render, staticRenderFns } from "./PcApp.vue?vue&type=template&id=e4ffeccc&"
import script from "./PcApp.vue?vue&type=script&lang=js&"
export * from "./PcApp.vue?vue&type=script&lang=js&"
import style0 from "./PcApp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports